import classNames from "classnames";
import React from "react";
import "./styles.scss";

function Select(props) {
  const { className, options, skipEmptyOption = false, ...rest } = props;
  return (
    <select {...rest} className={classNames("tg_select", className)}>
      {!skipEmptyOption && <option value="" disabled />}
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}

export default Select;
